import script from "./Quiz.vue?vue&type=script&setup=true&lang=js"
export * from "./Quiz.vue?vue&type=script&setup=true&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=2e56ef32&lang=css"

const __exports__ = script;

export default __exports__